var map = {
	"./bich_hut_chan_khong.jpg": 8091,
	"./daklak.png": 970,
	"./dau_100.jpg": 9502,
	"./dau_300.jpg": 1292,
	"./greyImage.jpg": 8456,
	"./hop_giay.jpg": 9304,
	"./maca_10.jpg": 6134,
	"./maca_12.jpg": 6532,
	"./maca_13.jpg": 8337,
	"./maca_14.jpg": 3106,
	"./maca_15.jpg": 4815,
	"./maca_18.jpg": 7326,
	"./maca_19.jpg": 1723,
	"./maca_2.jpg": 5939,
	"./maca_3.jpg": 9478,
	"./maca_4.jpg": 4237,
	"./maca_5.jpg": 3104,
	"./maca_6.jpg": 6719,
	"./maca_8.jpg": 3049,
	"./maca_9.jpg": 5004,
	"./maca_cake.jpg": 2865,
	"./maca_cookies.jpg": 9452,
	"./maca_flowers_2.jpg": 2838,
	"./maca_leaves.jpg": 5041,
	"./maca_nuts_16.jpg": 4559,
	"./maca_nuts_half_open.jpg": 6462,
	"./maca_pasta.jpg": 3244,
	"./maca_pumpkin_soup.png": 2579,
	"./maca_salad.jpg": 7230,
	"./maca_seedlings.jpg": 8339,
	"./maca_tofu.jpg": 349,
	"./maca_tofu_2.jpg": 890,
	"./maca_yoghurt_2.jpg": 5710,
	"./nhan_kho_sua.jpg": 5732,
	"./nhan_say_sua.jpg": 993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 452;